import { FC, Fragment, useCallback } from "react";
import { Chip, Stack, Typography } from "@mui/material";
import { TypographyWithTooltip } from "../../TypographyWithTooltip";
import { ProviderLogo } from "../../provider-logo/ProviderLogo";
import { FilterTriggerComponentProps } from "../../select/dropdown-select/utils/types/filterTriggerComponentProps";
import { AccountOptionType } from "../utils/types/types";

export const AccountSelectTriggerInputComponent: FC<
  FilterTriggerComponentProps
> = ({ options, selectedValues, disabled, setSelectedValues }) => {
  const allSelected = selectedValues.length === options.length;

  const account = options.find(
    (option) => option.value === selectedValues.at(0),
  )?.rawValue as AccountOptionType;

  const deleteAllHandler = useCallback(() => {
    setSelectedValues([]);
  }, [setSelectedValues]);

  const deleteHandler = useCallback(() => {
    setSelectedValues((selectedValues) =>
      selectedValues.filter((sv) => sv !== account.value),
    );
  }, [setSelectedValues, account]);

  return (
    <Stack p={1} direction="row" width="100%">
      {allSelected ? (
        <Chip
          size="small"
          variant="outlined"
          label="All accounts"
          disabled={disabled}
          onDelete={deleteAllHandler}
        />
      ) : (
        <Fragment>
          {account && (
            <Chip
              size="small"
              sx={{ pl: 1 }}
              variant="outlined"
              disabled={disabled}
              onDelete={deleteHandler}
              label={
                <TypographyWithTooltip
                  title={account.label}
                  fontSize="inherit"
                />
              }
              avatar={
                account.accountType ? (
                  <ProviderLogo provider={account.accountType} />
                ) : undefined
              }
            />
          )}

          {selectedValues.length > 1 && (
            <Typography
              ml={1}
              variant="body2"
              whiteSpace="nowrap"
              color="text.secondary"
            >
              + {selectedValues.length - 1} accounts
            </Typography>
          )}
        </Fragment>
      )}
    </Stack>
  );
};
